import { http } from '../../../../api/http';
import type { GuiaMateriaPrima, GuiaMateriaPrimaFormData, EstadoGuia } from '../types';

export class GuiaMateriaPrimaService {
  private static readonly BASE_URL = '/produccion/MateriaPrima';

  static async getAll(page: number = 1, pageSize: number = 10): Promise<{ data: GuiaMateriaPrima[]; totalCount: number }> {
    try {
      const response = await http.get(`${this.BASE_URL}/guias-recepcion?page=${page}&pageSize=${pageSize}`);

      // If the API returns an array directly, wrap it in the expected structure
      if (Array.isArray(response.data)) {
        return {
          data: response.data,
          totalCount: response.data.length
        };
      }

      // If the API returns the expected structure, use it
      return response.data;
    } catch (error) {
      console.error('Error fetching guias materia prima:', error);
      throw error;
    }
  }

  static async getById(id: number): Promise<GuiaMateriaPrima> {
    try {
      const response = await http.get(`${this.BASE_URL}/guias-recepcion/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching guia materia prima with id ${id}:`, error);
      throw error;
    }
  }

  static async create(data: GuiaMateriaPrimaFormData): Promise<GuiaMateriaPrima> {
    try {
      const response = await http.post(this.BASE_URL, data);
      return response.data;
    } catch (error) {
      console.error('Error creating guia materia prima:', error);
      throw error;
    }
  }

  static async update(id: number, data: GuiaMateriaPrimaFormData): Promise<GuiaMateriaPrima> {
    try {
      // The backend uses a single POST endpoint for create/update
      // Include the id in the data for update operations
      const requestData = { ...data, id };
      const response = await http.post(this.BASE_URL, requestData);
      return response.data;
    } catch (error) {
      console.error(`Error updating guia materia prima with id ${id}:`, error);
      throw error;
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await http.delete(`${this.BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error deleting guia materia prima with id ${id}:`, error);
      throw error;
    }
  }

  static async updateEstado(id: number, estado: EstadoGuia): Promise<void> {
    try {
      await http.patch(`${this.BASE_URL}/guias-recepcion/${id}/estado`, JSON.stringify(estado), {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } catch (error) {
      console.error(`Error updating estado for guia materia prima with id ${id}:`, error);
      throw error;
    }
  }
}